import { invoiceAPI, customerBusinessAPI, userBusinessAPI } from './api';
import dayjs from 'dayjs';
import { calculateVAT, calculateGrossAmount } from '../services/calculator';


export const createInvoiceNumber = async (nip, prefix) => {
  try {
    if(prefix===''|| prefix===undefined) prefix = 'XXX';
    const currentDate = new Date();
    const yearShort = String(currentDate.getFullYear()).slice(-2);
    const currentMonthYear = String(currentDate.getMonth() + 1).padStart(2, '0') + '/' + yearShort;


    // Pobierz faktury klienta (false = klient, true = sprzedawca)
    const response = await invoiceAPI.getByNIP(nip, false);

    if (!response || response.length === 0) {
      return `${prefix}/01/${currentMonthYear}`;
    }

    // 🔽 Filtruj tylko faktury o statusie "Wystawiona" (status === 0)
    const issuedInvoices = response.filter(invoice => invoice.status !== 4);
    console.log(issuedInvoices)

    if (issuedInvoices.length === 0) {
      return `${prefix}/01/${currentMonthYear}`;
    }

    // Wyciągnij numery faktur dla danego prefixu i bieżącego miesiąca
    const invoiceNumbers = issuedInvoices.map(invoice => invoice.number);
    const matchingNumbers = invoiceNumbers.filter(number =>
      number.startsWith(`${prefix}/`) && number.includes(currentMonthYear)
    );

    if (matchingNumbers.length === 0) {
      return `${prefix}/01/${currentMonthYear}`;
    }

    // Posortuj i wyciągnij ostatni numer
    matchingNumbers.sort();
    const lastNumber = matchingNumbers[matchingNumbers.length - 1]; // np. FABC/03/06/2025
    const lastSeq = parseInt(lastNumber.split('/')[1], 10); // 03

    const nextSeq = String(lastSeq + 1).padStart(2, '0');
    return `${prefix}/${nextSeq}/${currentMonthYear}`;
  } catch (error) {
    console.error('Błąd podczas generowania numeru faktury:', error);
    return '';
  }
};



  export const saveInvoice = async (formData, products, draft, id) => {
    const invoiceData = {
      number: formData.number,
      sellerName: formData.sellerName,
      sellerAddress: formData.sellerAddress,
      sellerNip: formData.sellerNip,
      buyerName: formData.buyerName,
      buyerAddress: formData.buyerAddress,
      buyerNIP: formData.buyerNIP,
      saleDate: formData.saleDate,
      invoiceDate: formData.invoiceDate,
      dateOfPayment: formData.dateOfPayment,
      payment: formData.payment,
      bankName: formData.bankName,
      accountNumber: formData.accountNumber,
      products: products.map((product) => ({
        productName: product.productName,
        quantity: parseInt(product.quantity),
        netAmount: parseFloat(product.netAmount),
        vatRate: product.vatRate,
        vatAmount: parseFloat(product.vatAmount),
        grossAmount: parseFloat(product.grossAmount),
      })),
    };
    if (draft) invoiceData.status = 4;
    try {
      if (typeof id === 'string' && /^\d+$/.test(id)) {
        await invoiceAPI.updateById(id, invoiceData);
        console.log("Faktura pomyślnie zaktualizowana.");
        return true; // oznacza update
      } else {
        await invoiceAPI.create(invoiceData);
        console.log("Faktura zapisana pomyślnie.");
        return false; // oznacza nowa
      }
    } catch (error) {
      console.error("Błąd podczas zapisywania faktury:", error);
      alert("Wystąpił błąd przy zapisywaniu faktury.");
      return false;
    }
  };
  

  export const createSellerAddress = (street, buildingNum, apartmentNum, city, postalCode, country) => {
    const buildingPart = apartmentNum ? `${buildingNum}/${apartmentNum}` : buildingNum;
    return `${street} ${buildingPart}, ${postalCode} ${city}, ${country}`;
  };
  

export const fetchClientsForSeller = async (sellerId, setClients) => {
  try {
    const response = await customerBusinessAPI.getByBusinessId(sellerId); // Zakładam, że masz endpoint dla klientów powiązanych ze sprzedawcą
    setClients(response);
  } catch (error) {
    console.error('Błąd podczas pobierania klientów:', error);
  }
  };

export const fetchBusinessDetails = async (invoiceNumber, setSellers, setClients, setFormData, setSelectedBusinessId) => {
  try {
    let sellerAddress = '';
    const sellerResponse = await userBusinessAPI.get();
    if (sellerResponse && sellerResponse.length > 0) {
      setSellers(sellerResponse);
      const { companyName, id, nipNumber } = sellerResponse[0];
      setSelectedBusinessId(id);
      sellerAddress = createSellerAddress(
        sellerResponse[0].street,
        sellerResponse[0].buildingNumber,
        sellerResponse[0].apartmentNumber,
        sellerResponse[0].city,
        sellerResponse[0].postalCode,
        sellerResponse[0].country
      );
      let invoiceNum = invoiceNumber;
      if(invoiceNumber==='')
        invoiceNum = await createInvoiceNumber(nipNumber);
      fetchClientsForSeller(id, setClients);
      setFormData((prevData) => ({
        ...prevData,
        sellerName: companyName,
        sellerAddress: sellerAddress,
        sellerNip: nipNumber,
        number: invoiceNum
      }));
    }
  } catch (error) {
    console.error('Błąd podczas pobierania danych sprzedawcy:', error);
  }
};

export const fetchInvoiceDetails = async (
  invoiceId,
  formData,
  setFormData,
  setProducts,
  setSellers,
  setClients,
  setSelectedBusinessId
) => {
  try {
    const invoiceResponse = await invoiceAPI.getById(invoiceId); // Pobierz fakturę
    if (invoiceResponse) {
      const {
        sellerName, buyerName, buyerNIP, buyerAddress,
        saleDate, invoiceDate, dateOfPayment, payment,
        bankName, accountNumber, products, number, status
      } = invoiceResponse;

      // Najpierw pobierz sprzedawców
      const sellersResponse = await userBusinessAPI.get();
      setSellers(sellersResponse);

      // Znajdź sprzedawcę na podstawie nazwy
      const matchedSeller = sellersResponse.find(s => s.companyName === sellerName);
      const matchedSellerId = matchedSeller ? matchedSeller.id : '';

      setSelectedBusinessId(matchedSellerId);

      const sellerAddress = matchedSeller
        ? createSellerAddress(
            matchedSeller.street,
            matchedSeller.buildingNumber,
            matchedSeller.apartmentNumber,
            matchedSeller.city,
            matchedSeller.postalCode,
            matchedSeller.country
          )
        : '';

      const sellerNip = matchedSeller ? matchedSeller.nipNumber : '';

      // Ustaw formData z sellerId, sellerAddress, sellerNip
      setFormData(prev => ({
        ...prev,
        sellerId: matchedSellerId,
        sellerName,
        sellerAddress,
        sellerNip,
        buyerName,
        buyerAddress,
        buyerNIP,
        saleDate: dayjs(saleDate),
        invoiceDate: dayjs(invoiceDate),
        dateOfPayment: dayjs(dateOfPayment),
        payment,
        bankName,
        accountNumber,
        number, 
        status
      }));

      setProducts(products);

      // Pobierz klientów dla tego sprzedawcy (jeśli znaleziony)
      if (matchedSellerId) {
        fetchClientsForSeller(matchedSellerId, setClients);
      }
    }
  } catch (error) {
    console.error('Błąd podczas pobierania szczegółów faktury:', error);
  }
};


export const handleSellerChange = async (sellerId, sellers, setSelectedBusinessId, setClients, setFormData, setFormErrors) => {
  const selectedSeller = sellers.find((seller) => seller.id === sellerId);
  if (!selectedSeller) {
    console.error('Nie znaleziono sprzedawcy o podanym ID');
    return;
  }

  let invoiceNum = '';
  let sellerAddress = createSellerAddress(
    selectedSeller.street,
    selectedSeller.buildingNumber,
    selectedSeller.apartmentNumber,
    selectedSeller.city,
    selectedSeller.postalCode,
    selectedSeller.country
  );

  setSelectedBusinessId(selectedSeller.id);
  fetchClientsForSeller(selectedSeller.id, setClients);
  invoiceNum = await createInvoiceNumber(selectedSeller.nipNumber);

  setFormData((prevData) => ({
    ...prevData,
    sellerId: selectedSeller.id,
    sellerName: selectedSeller.companyName,
    sellerAddress: sellerAddress,
    sellerNip: selectedSeller.nipNumber,
    buyerName: '',
    accountNumber: selectedSeller.accountNumber,
    bankName: selectedSeller.bankName,
    number: invoiceNum
  }));
   setFormErrors(prev => ({
      ...prev,
      bankName: undefined,
      accountNumber: undefined,
    }));
};


export const handleErrorChange = (name, setFormErrors) =>{
  setFormErrors((prevErrors) => {
    const newErrors = { ...prevErrors };
    delete newErrors[name];
    return newErrors;
  });
}

////METODY DOTYCZACE PRODUKTU//////////////
export const handleProductChange = (index, event, setProducts, products, setFormErrors) => {
  const { name, value } = event.target;
  const updatedProducts = [...products];
  updatedProducts[index][name] = value;

  const vatAmount = calculateVAT(updatedProducts[index].netAmount, updatedProducts[index].vatRate, updatedProducts[index].quantity);
  const grossAmount = calculateGrossAmount(updatedProducts[index].netAmount, vatAmount, updatedProducts[index].quantity);

  updatedProducts[index].vatAmount = vatAmount;
  updatedProducts[index].grossAmount = grossAmount;

  setProducts(updatedProducts);
  handleErrorChange(`${name}_${index}`, setFormErrors);
};

export const addProduct = (products, setProducts) => {
  setProducts([...products, { productName: '', quantity: 1, netAmount: 0, vatRate: '5%', vatAmount: 0, grossAmount: 0 }]);
};

export const removeProduct = (index, products, setProducts) => {
  const updatedProducts = products.filter((_, i) => i !== index);
  setProducts(updatedProducts);
};

/////METODY DOTYCZACE KLIENTA/////////////

export const handleClientChange = (value, clients, setFormData, setFormErrors) => {
  const selectedBuyer = clients.find((buyer) => buyer.name === value);
  if(selectedBuyer){
    setFormData((prevData) => ({
      ...prevData,
      buyerName: value,
      buyerAddress: selectedBuyer.address,
      buyerNIP: selectedBuyer.nip,

    }));
    handleErrorChange('buyerName', setFormErrors);
  }
}